import { SVGProps } from "react";

export default function DashboardOnboardingPendingIcon(
  props: SVGProps<SVGSVGElement>,
) {
  const { height = 24, width = 24, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.5 4.20996V4.21996M4.20996 7.5V7.51M3 12V12.01M4.20996 16.5V16.51M7.5 19.79V19.8M12 21V21.01M16.5 19.79V19.8M19.79 16.5V16.51M21 12V12.01M19.79 7.5V7.51M16.5 4.20996V4.21996M12 3V3.01"
        stroke="#232323"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 4.20996V4.21996M4.20996 7.5V7.51M3 12V12.01M4.20996 16.5V16.51M7.5 19.79V19.8M12 21V21.01M16.5 19.79V19.8M19.79 16.5V16.51M21 12V12.01M19.79 7.5V7.51M16.5 4.20996V4.21996M12 3V3.01"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
